import { Component, Input, OnInit } from '@angular/core';
import { ZoningCodeVersion } from '../../../models/zoning-code-version';
import { ZoningCodeVersionService } from '../../../services/zoning-code-version.service';
import { map } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-update-zcv-status-button',
    templateUrl: './update-zcv-status-button.component.html',
    styleUrls: ['./update-zcv-status-button.component.scss']
})
export class UpdateZcvStatusButtonComponent implements OnInit {
    @Input()
    zoningCodeVersion: ZoningCodeVersion;

    @Input()
    stateEnv: string;

    constructor(protected readonly zoningCodeVersionService: ZoningCodeVersionService) {}

    ngOnInit(): void {}

    updateZCVStatus() {
        return this.zoningCodeVersionService.updateZCVStatus(this.zoningCodeVersion, this.stateEnv).pipe(
            map(zoningCodeVersion => {
                this.zoningCodeVersion.initValues(zoningCodeVersion);
                return true;
            })
        );
    }
}
